var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "comment-text_2",
    d: "M12 4.43518C7.03 4.43518 3 7.43516 3 12.4362C3 14.5562 3.72995 16.3272 4.94995 17.6472C4.79995 18.6072 4.25992 19.7072 3.16992 20.5872C2.83992 20.8672 3.02996 21.4171 3.45996 21.4271C4.87996 21.4771 7.06991 21.2872 8.40991 19.8572C9.50991 20.2372 10.72 20.4371 12 20.4371C16.97 20.4371 21 17.4362 21 12.4362C21 7.43516 16.97 4.43518 12 4.43518ZM13 15.1852H8C7.586 15.1852 7.25 14.8492 7.25 14.4352C7.25 14.0212 7.586 13.6852 8 13.6852H13C13.414 13.6852 13.75 14.0212 13.75 14.4352C13.75 14.8492 13.414 15.1852 13 15.1852ZM16 11.1852H8C7.586 11.1852 7.25 10.8492 7.25 10.4352C7.25 10.0212 7.586 9.68518 8 9.68518H16C16.414 9.68518 16.75 10.0212 16.75 10.4352C16.75 10.8492 16.414 11.1852 16 11.1852Z",
    fill: "#707496"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.2fa5208cc231556df0dfb2c02c57178e.svg";
export { ForwardRef as ReactComponent };